import React from "react";
import "../Partner/Partner.css";

const Partner = () => {
  return (
    <section className="partner">
      <div className="partner-images">
        <img src="p1.webp" alt="Partner 1" />
        <img src="p2.webp" alt="Partner 2" />
        <img src="p3.webp" alt="Partner 3" />
        <img src="p4.webp" alt="Partner 4" />
        <img src="p5.webp" alt="Partner 5" />
      </div>
    </section>
  );
};

export default Partner;
